import { getCardColorTags } from './../../../../../../../../store/model/selectors/getCardColorTags';
import { connect } from 'react-redux';
import * as React from 'react';
import { EMPTY_ARRAY, IApplicationState } from '../../../../../../../../types/types';
import { ICardHOCProps } from './types';
import { ICardEvents, ICardFields } from '../../components/Card/types';
import { onCardClick } from './events/onCardClick';
import { Card } from '../../components/Card/Card';
import { getCardCollaborators } from '../../../../../../../../store/model/selectors/getCardCollaborators';
import { isCardHasActiveRequests } from '../../../../../../../../store/model/card/selectors/isCardHasActiveRequests';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';
import { getBoardIdByCardId } from '../../../../../../../../store/model/selectors/getBoardIdByCardId';
import { onDidMount } from './events/onDidMount';
import { getBoardPermissionsIsReadonly } from '../../../../selectors/getBoardPermissionsIsReadonly';
import { getCardFullName } from '../../../../../../../../store/model/card/selectors/getCardFullName';
import { TStatus } from '../../../../../../../../types/model';
import { getCardPinnedSectionsNoreselect } from '../../../../../../../../store/model/selectors/getCardPinnedSections';
import { getBoardRolesSortedCreateSelector } from '../../../../../../../../store/model/board/selectors/getBoardRolesSorted';
import { getAuthUser } from '../../../../../../../../store/model/authUser/selectors/getAuthUser';
import { getDraggableCardId } from '../../../../store/selectors/getDraggableCardId';
import { getSelectedCards } from '../../../../../../clickManager/selectors/getSelectedCards';
import { isCardSelected } from '../../../../../../clickManager/selectors/isCardSelected';
import { getDriveDocsByCardIdCreateSelector } from '../../../../../../../../store/model/driveDocs/selectors/getDriveDocsByCardId';
import { root } from '../../../../../../../../store/constants';
import { ERestDriveDocType } from '../../../../../../../../types/rest/IRestDriveDoc';
import { getCardPinnedCustomPropertiesIds } from '../../../../../../../../store/model/selectors/getCardPinnedCustomPropertiesIds';
import { getHighlightCardId } from '../../../../store/selectors/getHighlightCardId';
import { onAnimationEnd } from './events/onAnimationEnd';
import { getRecentlyWatchCardId } from '../../../../store/selectors/getRecentlyWatchedCardId';
import { getCurrentNotFilledCardId } from '../../../../../../aside_panel/cardDetails/store/selectors/getCurrentNotFilledCardId';
import { getCardTimeSinceLastActivity } from './selectors/getCardTimeSinceLastActivity';
import { getCardTimeSinceMovedToList } from './selectors/getCardTimeSinceMovedToList';
import { getIsCardAgingOpacity } from './selectors/getIsCardAgingOpacity';
import { getCardAgingIndicator } from './selectors/getCardAgingIndicator';
import { getIsCardMultiselect } from '../../../../../../clickManager/selectors/getIsCardMultiselect';
import { onCheckboxClick } from './events/onCheckboxClick'
import { isEqual } from 'underscore';
import { getBoardMetaDefaultTemplateCardId } from '../../../../../../../../store/model/selectors/getBoardMetaDefaultTemplateCardId';
import { isRelatedCardsPanelOpened } from 'app/view/react_components/aside_panel/relatedCards/store/selectors/isRelatedCardsPanelOpened';
import { onQuickLookChange } from './events/onQuickLookChange';
import { Util } from 'app/util/util';
import { onLoadData } from './events/onLoadData';
import { getCardChecklists } from '../../../../../../../../store/model/checklists/checklists/selectors/getCardChecklists';
import { getIsShowKnbCardAgeing } from './selectors/getIsShowKnbCardAgeing';
import { getIsKnbCardTagsHidden } from './selectors/getIsKnbCardTagsHidden';
import { getIsShowKnbCardAssignees } from './selectors/getIsShowKnbCardAssignees';
import { getIsShowKnbCardColorTags } from './selectors/getIsShowKnbCardColorTags';
import { getIsShowKnbCardCounters } from './selectors/getIsShowKnbCardCounters';
import { getIsShowKnbCardDueDate } from './selectors/getIsShowKnbCardDueDate';
import { getIsShowKnbCardEmptyProperties } from './selectors/getIsShowKnbCardEmptyProperties';
import { getIsShowKnbCardEstimate } from './selectors/getIsShowKnbCardEstimate';
import { getIsShowKnbCardPrefixes } from './selectors/getIsShowKnbCardPrefixes';
import { getIsShowKnbCardPriority } from './selectors/getIsShowKnbCardPriority';
import { getIsShowKnbCardProgress } from './selectors/getIsShowKnbCardProgress';
import { getIsShowKnbCardStartDate } from './selectors/getIsShowKnbCardStartDate';
import { getCustomPropertiesCreateSelector } from '../../../../../../aside_panel/cardDetails/CustomPropertiesSection/hocs/selectors/getCustomProperties';
import { getCardSubcardsCount } from '../../../../../../../../store/model/selectors/getCardSubcardsCount';
import { getCardSubcardsSorted } from '../../../../../../../../store/model/selectors/getCardSubcards';
import { onDoubleClickEvent } from './events/onDoubleClickEvent';
import { getEditedNameCardId } from '../../../../store/selectors/getEditedNameCardId';
import { onHideHint } from './events/onHideHint';

// const analyze = new Analyze('CardHOC');
// (reselect) average: 0.058 ms, calls: 226512, total: 13190.835 ms
// (_.isEqual) average: 0.049 ms, calls: 56144, total: 2758.950 ms
// 2022-12-16:
// (isEqualOneLevel) average: 0.029 ms, calls: 18884, total: 549.300 ms (непустые mainDriveDocSet не кэшируются)
// (isEqual) average: 0.042 ms, calls: 17743, total: 743.000 ms (полный кэш)
// (isEqual + убрал реселекты) average: 0.030 ms, calls: 18000, total: 546.100 ms

const mapStateToProps = () => {
    const getBoardRolesSorted = getBoardRolesSortedCreateSelector();
    const getCustomProperties = getCustomPropertiesCreateSelector();
    const getDriveDocs = getDriveDocsByCardIdCreateSelector();

    let cardCache: ICardFields = null;
    const getCardCache = (
        card: ICardFields
    ): ICardFields => {
        if (isEqual(card, cardCache)) {
            return cardCache;
        }
        cardCache = card;
        if (root._debug.selector) {
            console.log('getCardCache ');
        }
        return card;
    };

    return (
        state: IApplicationState,
        props: ICardHOCProps
    ): ICardFields => {
        const {cardId, height, actionsPortalId} = props;
        const boardId = getBoardIdByCardId(state, cardId);
        const cardStore = getCard(state, cardId);
        const {
            assignees = EMPTY_ARRAY,
            backgroundColor,
            cardNumber,
            checklistStats,
            colorIds = EMPTY_ARRAY,
            commentCount,
            description,
            driveDocCount,
            dueDate,
            epicId,
            estimate = 0,
            isFullLoaded,
            isQuickLookCollapse,
            listId,
            name,
            openedQuickLook,
            priority,
            processingPercent,
            processingStatus,
            recurringTasks = EMPTY_ARRAY,
            startDate,
            status,
            tags = EMPTY_ARRAY,
        } = cardStore;

        // analyze.start();
        const collaborators = getCardCollaborators(state, cardId); // без реселекта - все ок
        const colorTags = colorIds.length && getCardColorTags(state, cardId); // без реселекта
        const epicName = getCardFullName(state, epicId); // без реселекта - все ок
        const isFakeCovered = isCardHasActiveRequests(state, cardId);
        const isCovered = Date.now() - cardStore.created * 1000 <= 5000 && // KNB-3401 лоудер только при создании карты
            isCardHasActiveRequests(state, cardId); // без реселекта - все ок
        const isSelected = isCardSelected(state, boardId, cardId); // без реселекта
        const mainDriveDocSet = driveDocCount ? getDriveDocs(state, cardId, ERestDriveDocType.CARD, true, true) : EMPTY_ARRAY; //реселект - все ок
        const subCardsCount = getCardSubcardsCount(state, cardId);  // без реселекта - все ок
        const subcards = subCardsCount ? getCardSubcardsSorted(state, cardId) : EMPTY_ARRAY;
        const pinnedSections = getCardPinnedSectionsNoreselect(state, cardId); // без реселекта
        const pinnedChecklists = pinnedSections.checklists ? pinnedSections.checklists : EMPTY_ARRAY;
        const boardRoles = collaborators.length && getBoardRolesSorted(state, boardId); //реселект - все ок
        const { allowCardAgeing } = getAuthUser(state); //реселект - все ок
        const draggableCardId = getDraggableCardId(state); // без реселекта - все ок
        const selectedCards = getSelectedCards(state, boardId); // без реселекта - все ок
        const isRecentlyWatched = getRecentlyWatchCardId(state) === cardId;
        const isNotFilled = getCurrentNotFilledCardId(state) === cardId;
        const cardAgingIndicator = !allowCardAgeing ? null : getCardAgingIndicator(state, cardStore);
        const isCardAgingOpacity = !allowCardAgeing ? null : getIsCardAgingOpacity(state, cardStore);
        const timeSinceLastActivity = !cardAgingIndicator ? null : getCardTimeSinceLastActivity(cardStore);
        const timeSinceMovedToList = !cardAgingIndicator ? null : getCardTimeSinceMovedToList(cardStore);
        const editedNameCardId = getEditedNameCardId(state);
        // const isRelatedPanel = isRelatedPanelClosed(state);
        const isRelatedPanel = isRelatedCardsPanelOpened(state)
        const isRelatedCardEdit = isRelatedPanel && state.relatedCards.cardId === cardId;
        const { totalCount = 0, checkedCount = 0 } = checklistStats || {};
        // т.к. мы скрываем каунтер, если у нас все чеклисты запинены,
        // то теперь пока карта не загружена, нужно понять есть ли на карте чеклисты или нет
        // пустые чеклисты игнорируются (показываем пустыми только запиненные чеклисты)
        const checklists = getCardChecklists(state, cardId); // без реселекта - все ок , пустой объек {} нам не страшен внутри
        let _totalCount = 0;
        let _checkedCount = 0;
        for (let checklistId in checklists) {
            if (pinnedChecklists.includes(Number(checklistId))) {
                const items = Object.values(checklists[checklistId].checkItems);
                _totalCount += items.length
                _checkedCount += items.filter(item => item.checked).length;
            }
            if (_totalCount > totalCount) break;
        }
        const isShowChecklistsCounter = totalCount > _totalCount;

        // Если перетаскивается карта из выделения и текущая карта так же в выделении
        const isMultipleDragging = draggableCardId && draggableCardId !== cardId && selectedCards.includes(draggableCardId) && selectedCards.includes(cardId);
        const isMultiselect = getIsCardMultiselect(state, boardId) || isRelatedPanel && !isRelatedCardEdit;

        const customProperties = pinnedSections.customProperties && getCustomProperties(state, boardId, cardId, true);

        const card = getCardCache({
            actionsPortalId,
            boardId,
            assignees,
            attachmentsCount: driveDocCount - mainDriveDocSet.length || 0,
            backgroundColor,
            cardNumber,
            customProperties,
            dueDate,
            isShowChecklistsCounter,
            checklists: checklists,
            checklistsItemsCount: totalCount - _totalCount,
            commentCount,
            description: Boolean(description) && Util.fixAuthuser(description),
            doneChecklistsCount: checkedCount - _checkedCount,
            editedNameCardId,
            epicName,
            estimate,
            recurringTasks,
            hasDescription: Boolean(description),
            height,
            id: cardId,
            isFullLoaded,
            listId,
            name,
            openedQuickLook,
            percent: processingPercent,
            priority,
            processingStatus,
            startDate,
            tags,

            collaborators,
            isHighlight: getHighlightCardId(state) === cardId,
            colorTags,
            isCovered,
            isNotFilled,
            isSelected,
            isFakeCovered,
            isRecentlyWatched,
            isRelatedCardEdit,
            isRelatedPanel,
            isTemplate: status === TStatus.STATUS_SERVICE_TEMPLATE,
            mainDriveDocSet,
            subcards,
            subCardsCount,
            boardRoles,
            isCardAgingOpacity,
            cardAgingIndicator,
            timeSinceLastActivity,
            timeSinceMovedToList,

            isShowAgeing: getIsShowKnbCardAgeing(state, boardId),
            isShowAssignees: getIsShowKnbCardAssignees(state, boardId),
            isShowColorTags: getIsShowKnbCardColorTags(state, boardId),
            isShowCounters: getIsShowKnbCardCounters(state, boardId),
            isShowDueDate: getIsShowKnbCardDueDate(state, boardId),
            isShowEmptyProperties: getIsShowKnbCardEmptyProperties(state, boardId),
            isShowEstimate: getIsShowKnbCardEstimate(state, boardId),
            isShowPrefixes: getIsShowKnbCardPrefixes(state, boardId),
            isShowPriority: getIsShowKnbCardPriority(state, boardId),
            isShowProgress: getIsShowKnbCardProgress(state, boardId),
            isShowStartDate: getIsShowKnbCardStartDate(state, boardId),
            isShowTags: getIsKnbCardTagsHidden(state, boardId),

            pinnedChecklistCount: pinnedChecklists.length,
            isPinnedDescription: pinnedSections.description,
            isPinnedSubcards: pinnedSections.subcards,
            isPinnedCustomProperties: customProperties && !!customProperties.length,
            isReadonly: getBoardPermissionsIsReadonly(state, boardId),
            isQuickLookCollapse,
            isMultipleDragging,
            isMultiselect,
            isDefaultTemplate: getBoardMetaDefaultTemplateCardId(state, boardId) === cardId
        });
        // analyze.finish();

        return card;
    };
};

const mapDispatchToProps = (
    dispatch: any,
    {cardId}: ICardHOCProps
): ICardEvents => {
    return {
        onCardClick: (e: React.MouseEvent) => dispatch(onCardClick(e, cardId)),
        onDidMount: () => dispatch(onDidMount(cardId)),
        onAnimationEnd: () => dispatch(onAnimationEnd(cardId)),
        onCheckboxClick: () => dispatch(onCheckboxClick(cardId)),
        onQuickLookChange: (quickLook) => dispatch(onQuickLookChange(cardId, quickLook)),
        onLoadData: () => dispatch(onLoadData(cardId)),
        onDoubleClickEvent: () => dispatch(onDoubleClickEvent()),
        onHideHint: () => dispatch(onHideHint()),
    };
};

export const CardHOC = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Card);

CardHOC.displayName = 'CardHOC';
